export default __webpack_public_path__ + "static/media/loia-rose-logo.5e11be2c.svg";